// extracted by mini-css-extract-plugin
export default {"SurfaceObjetSelectionnable":"SurfaceObjetSelectionnable_SurfaceObjetSelectionnable__tfKUM","Selected":"SurfaceObjetSelectionnable_Selected__DkpKD"};